import React, {useEffect, useState} from 'react';

import "./Profile.css";
import {ProfileCard} from "./profile-card/ProfileCard";
import notificationIcon from "../../../resources/images/dashboard-notifications-icon.png";
import appointmentIcon from "../../../resources/images/dashboard-appointments-icon.png";
import problemIcon from "../../../resources/images/dashboard-facilities-icon.png";
import alertIcon from "../../../resources/images/alerts_icon.png";
import {loadUserProfile} from "../../../services/AccountService";

export const Profile = ({context, setContext, navigateTo, showToaster, setSpinnerText}) => {

    const [noOfAppointmentsForUser, SetNoOfAppointmentsForUser] = useState(0);
    const [noOfNotifications, SetNoOfNotifications] = useState(0);
    const [noOfProblemsForUser, SetNoOfProblemsForUser] = useState(0);
    const [noOfAlerts, SetNoOfAlerts] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            await loadProfile();
        }
        fetchData();
    }, []);

    const loadProfile = async () => {
        setSpinnerText("Loading profile");
        const [data, error] = await loadUserProfile(context.username);
        if (data) {
            if (data.responseStatus === "Success") {
                SetNoOfAppointmentsForUser(data.userProfileVO.noOfAppointmentsForUser);
                SetNoOfProblemsForUser(data.userProfileVO.noOfProblemsForUser);
                SetNoOfNotifications(data.userProfileVO.noOfNotifications);
                SetNoOfAlerts(data.userProfileVO.alertVOS.length);
            } else {
                if (data.responseMessage !== "There was an error when trying to load the User Profile. Unable to find visits in the database") {
                    showToaster(data);
                }
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setSpinnerText(null);
    }

    const notificationImage = <img src={notificationIcon} alt="Aurum Logo" className="wizard-icon"/>;
    const appointmentImage = <img src={appointmentIcon} alt="Aurum Logo" className="wizard-icon"/>;
    const problemImage = <img src={problemIcon} alt="Aurum Logo" className="wizard-icon"/>;
    const alertImage = <img src={alertIcon} alt="Aurum Logo" className="wizard-icon"/>;

    return (
        <div>
            <div className="profile-container">
                <div className="profile-content-container">
                    <p>Hello, {context.username}!</p>
                    <p>Here are your tasks at a glance:</p>
                    <div className="profile-cards-container">
                        <ProfileCard setContext={setContext} image={notificationImage}
                                     alertCount={noOfNotifications} title={"Notifications"}
                                     path="notificationView" navigateTo={navigateTo}/>
                        <ProfileCard setContext={setContext} image={alertImage}
                                     alertCount={noOfAlerts} title={"Alerts"}
                                     path="alertView" navigateTo={navigateTo}/>
                        <ProfileCard setContext={setContext} image={appointmentImage}
                                     alertCount={noOfAppointmentsForUser} title={"Appointments"}
                                     path="appointmentView" navigateTo={navigateTo}/>
                        <ProfileCard setContext={setContext} image={problemImage}
                                     alertCount={noOfProblemsForUser} title={"Problems"}
                                     path="myProblems" navigateTo={navigateTo}/>
                    </div>
                </div>
            </div>
        </div>
    );
}
